import { app } from '../app';

app.factory('CompanyUser', CompanyUser);

/** @ngInject */
function CompanyUser($resource) {
    return $resource('app/rest/companies/:companyId/companyusers/:id', {
        companyId : '@companyId',
        id : "@id"
    }, {
        'identifyCompanyUser' : {
            method : 'GET',
            url : 'app/rest/companies/:companyId/companyusers?uid=:uid',
            params : {
                companyId : '@companyId',
                uid : '@uid'
            }
        },
        'getUserAccounts' : {
            method : 'GET',
            url : 'app/rest/companies/:companyId/companyusers/:id/useraccounts',
            isArray : true,
            params : {
                companyId : '@companyId',
                id : '@id'
            }
        },
        'updateCompanyUser' : {
            method : 'POST',
            url : 'app/rest/companies/:companyId/companyusers/:id?update=:updateAction',
            params : {
                companyId : '@companyId',
                id : '@id',
                updateAction : '@updateAction'
            }
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/services/company-user.service.js